'use client'
import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import clsx from 'clsx'

import useIsMobile from '@/hooks/useIsMobile'

import MenuFooterHeader from './Header'
import MenuFooterMain from './Main'

import { MenuFooterProps } from './FooterMenu.types'
import styles from './FooterMenu.module.scss'

const MenuFooter = ({
  className = null,
  collapsable = true,
  collapsableLabel = null,
  headerLabel = null,
  direction = 'column',
  main,
  theme = 'dark',
}: MenuFooterProps) => {
  const isMobile = useIsMobile()
  const [isOpen, setIsOpen] = useState(false)

  const onButtonClick = () => {
    if (!isMobile) return
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    setIsOpen(!isMobile)
    return
  }, [isMobile])

  const mainExists = !!main

  return (
    <div className={clsx(className, styles.footerMenuWrapper)}>
      {headerLabel && (
        <MenuFooterHeader
          headerLabel={headerLabel}
          mainExists={mainExists}
          isMobile={isMobile}
          collapsable={collapsable}
          collapsableLabel={collapsableLabel}
          isOpen={isOpen}
          onButtonClick={onButtonClick}
        />
      )}

      {main && (
        <MenuFooterMain
          className={clsx((isOpen || !collapsable) && styles.footerMenuVisible)}
          layout
          as={motion.main}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          direction={direction}
          items={main}
          theme={theme}
        />
      )}
    </div>
  )
}

export default MenuFooter
